
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Package,
  ShoppingCart,
  Users,
  Settings,
  LogOut,
  Store,
} from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const LINKS = [
  { to: "/admin", icon: LayoutDashboard, label: "Dashboard" },
  { to: "/admin/products", icon: Package, label: "Produits" },
  { to: "/admin/orders", icon: ShoppingCart, label: "Commandes" },
  { to: "/admin/users", icon: Users, label: "Clients" },
  { to: "/admin/settings", icon: Settings, label: "Paramètres" },
];

export default function AdminSidebar({ collapsed }) {
  const { logout } = useAuth();

  return (
    <aside
      className={`fixed left-0 top-0 z-40 flex min-h-screen flex-col overflow-hidden bg-[#0f0f1a] text-white transition-[width] duration-300 ${
        collapsed ? "w-[70px]" : "w-60"
      }`}
    >
      {/* Logo */}
      <div className="border-b border-white/[0.07] px-4 py-6">
        <div className="flex items-center gap-2.5">
          <Store
            size={22}
            className="shrink-0 text-violet-500"
          />

          {!collapsed && (
            <span className="whitespace-nowrap text-base font-bold tracking-wide">
              Splendrofify
            </span>
          )}
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 space-y-1 py-4">
        {LINKS.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/admin"}
            title={collapsed ? label : undefined}
            className={({ isActive }) =>
              `mx-0 flex items-center gap-3 border-l-[3px] px-[15px] py-3 text-sm transition-colors duration-200 ${
                isActive
                  ? "border-violet-500 bg-violet-500/15 text-white"
                  : "border-transparent text-white/50 hover:bg-white/5 hover:text-white"
              }`
            }
          >
            <Icon size={18} className="shrink-0" />

            {!collapsed && (
              <span className="whitespace-nowrap">{label}</span>
            )}
          </NavLink>
        ))}
      </nav>

      {/* Déconnexion */}
      <div className="border-t border-white/[0.07] p-4">
        <button
          type="button"
          onClick={logout}
          title={collapsed ? "Déconnexion" : undefined}
          className="flex w-full items-center gap-3 rounded-lg px-1 py-2 text-sm text-white/50 transition-colors duration-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-violet-500"
        >
          <LogOut size={18} className="shrink-0" />

          {!collapsed && (
            <span className="whitespace-nowrap">Déconnexion</span>
          )}
        </button>
      </div>
    </aside>
  );
}
